var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDismissCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dismiss Circle Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M10.0003 1.66666C14.6027 1.66666 18.3337 5.39762 18.3337 10C18.3337 14.6024 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6024 1.66699 10C1.66699 5.39762 5.39795 1.66666 10.0003 1.66666ZM12.9423 7.05806L12.8722 6.99754C12.6547 6.83617 12.3562 6.83417 12.1367 6.99156L12.0584 7.05806L10.0003 9.11583L7.94227 7.05806L7.87217 6.99754C7.65468 6.83617 7.35617 6.83417 7.13668 6.99156L7.05838 7.05806L6.99787 7.12815C6.8365 7.34564 6.8345 7.64416 6.99189 7.86365L7.05838 7.94194L9.11616 10L7.05838 12.0581L6.99787 12.1282C6.8365 12.3456 6.8345 12.6442 6.99189 12.8636L7.05838 12.9419L7.12848 13.0025C7.34597 13.1638 7.64448 13.1658 7.86398 13.0084L7.94227 12.9419L10.0003 10.8842L12.0584 12.9419L12.1285 13.0025C12.346 13.1638 12.6445 13.1658 12.864 13.0084L12.9423 12.9419L13.0028 12.8718C13.1642 12.6544 13.1661 12.3558 13.0088 12.1363L12.9423 12.0581L10.8845 10L12.9423 7.94194L13.0028 7.87184C13.1642 7.65435 13.1661 7.35584 13.0088 7.13635L12.9423 7.05806L12.8722 6.99754L12.9423 7.05806Z",
    fill: "#9B9DAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDismissCircleFilled);
export default __webpack_public_path__ + "static/media/dismiss_circle_filled.02b2e5510369bb7e3003fb5dea81b2d9.svg";
export { ForwardRef as ReactComponent };